@if (title) {
    <h4 class="articles-carousel-block__heading">{{ title }}</h4>
}
<div class="articles-carousel-block__container">
    @for (page of pages$$(); track page; let index = $index) {
        <section
            class="articles-carousel-block__container__section"
            [class.articles-carousel-block__container__section--fade-in]="
                selectedIndex$$() === index
            "
            [class.articles-carousel-block__container__section--fade-out]="
                selectedIndex$$() !== index
            "
        >
            <nw-articles-block [articles]="page"></nw-articles-block>
        </section>
    }
    <div class="articles-carousel-block__container__pagination">
        <button
            nw-outline-button
            class="articles-carousel-block__container__pagination__button articles-carousel-block__container__pagination__button--prev"
            (click)="changePage(selectedIndex$$() - 1, $event)"
        >
            <nw-icon
                ><svg
                    xmlns="http://www.w3.org/2000/svg"
                    fill
                    viewBox="0 0 13 22"
                    height="13px"
                >
                    <path
                        fill="currentColor"
                        d="M.94 9.94a1.502 1.502 0 0 0 0 2.124l9 9a1.502 1.502 0 0 0 2.124-2.123L4.124 11l7.935-7.94A1.502 1.502 0 0 0 9.936.935l-9 9 .004.005Z"
                    />
                </svg>
            </nw-icon>
        </button>
        <nw-pill>{{ selectedIndex$$() + 1 }} / {{ pages$$().length }}</nw-pill>
        <button
            nw-outline-button
            class="articles-carousel-block__container__pagination__button articles-carousel-block__container__pagination__button--next"
            (click)="changePage(selectedIndex$$() + 1, $event)"
        >
            <nw-icon
                ><svg
                    xmlns="http://www.w3.org/2000/svg"
                    fill
                    viewBox="0 0 13 22"
                    height="13px"
                >
                    <path
                        fill="currentColor"
                        d="M12.06 9.94a1.502 1.502 0 0 1 0 2.124l-9 9a1.502 1.502 0 0 1-2.124-2.123L8.876 11 .942 3.06A1.502 1.502 0 0 1 3.064.935l9 9-.005.005Z"
                    />
                </svg>
            </nw-icon>
        </button>
    </div>
</div>
